const styles = {
  text: {
    fontSize: 10,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    paddingLeft: 4,
    paddingRight: 4,
  },
  brick: {
    width: 85,
    borderRadius: 2,
    border: "none",
    backgroundColor: "#F2F2F2",
    height: 21,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  area: {
    backgroundColor: "transparent",
    border: "1px solid #4327AE",
  },
  areaFilled: {
    backgroundColor: "#4327AE",
    color: "white",
  },
  zone: {
    border: "1px solid #0B15FA",
  },
  zoneFilled: {
    backgroundColor: "#0B15FA",
    color: "white",
  },
  region: {
    border: "1px solid #0BB2FA",
  },
  regionFilled: {
    backgroundColor: "#0BB2FA",
    color: "white",
  },
  chapter: {
    border: "1px solid #0BAB5E",
  },
  chapterFilled: {
    backgroundColor: "#0BAB5E",
    color: "white",
  },
  district: {
    border: "1px solid #F97D0A",
  },
  districtFilled: {
    backgroundColor: "#F97D0A",
    color: "white",
  },
};

export default styles;
